import { useMutation, useQueryClient } from "@tanstack/react-query";
import { editTile } from "@/services/review.service";
import { EditTileRequest } from "@/types/review.types";

export const useTileEdit = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: EditTileRequest) => editTile(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["reviews"] });
    },
  });
};
